module.exports = __webpack_public_path__ + "static/img/close_img.31fd578.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20231111/close_img.jpg
// module id = gSW7
// module chunks = 0